import { Link } from "react-router-dom";

const ForgotPasswordLink = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="text-sm">
        <Link
          to="/forgot-password"
          className="font-semibold leading-6 text-accent-600 hover:text-accent-500"
        >
          Forgot password?
        </Link>
      </div>
    </div>
  );
};

export default ForgotPasswordLink;
